// @flow
export const PIN_NAV: string = 'PIN_NAV';
export const RECEIVE_VERSIONS: string = 'RECEIVE_VERSIONS';
export const TOGGLE_PRIVATE: string = 'TOGGLE_PRIVATE';
export const UNPIN_NAV: string = 'UNPIN_NAV';



// WEBPACK FOOTER //
// ./src/reducers/app/constants.js